import { render, staticRenderFns } from "./PrioritySelector.vue?vue&type=template&id=9039aeb2"
import script from "./PrioritySelector.vue?vue&type=script&lang=ts"
export * from "./PrioritySelector.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports